import reducer from "./reducer";
export { default as AllergiesExamsDiseases } from "./components/index";
export { default as allergiesExamsDiseasesReducerName } from "./constants";
export default reducer;
